import { resolveText } from '../../i18n/resolveText';
import { i18nService } from '../../i18n/I18nService';
import { fetchPlaces } from '../../api/placesApi';
import { authService } from '../../auth/AuthService';
import { formatEuros } from '../../utils/format';
function renderPlaceCard(place, ctaLabel, isLast) {
    const locale = i18nService.getLocale();
    const tiers = [
        { value: place.pricePerHour, labelKey: 'home.workspacesRail.priceChips.hour' },
        { value: place.pricePer3Hours, labelKey: 'home.workspacesRail.priceChips.threeHours' },
        { value: place.pricePerDay, labelKey: 'home.workspacesRail.priceChips.day' },
    ];
    const rows = tiers
        .filter((tier) => tier.value != null)
        .map((tier) => `<div class="price-row"><span>${i18nService.t(tier.labelKey)}</span><span class="price-row__price">${formatEuros(tier.value)}</span></div>`)
        .join('');
    return `
    <article class="card${isLast ? ' card--last' : ''}">
      <div class="card__image">
        <img src="${place.photo ?? ''}" alt="${place.name[locale]}" style="object-position:50% 50%;">
      </div>
      <div class="card__body">
        <h3 class="card__title">${place.name[locale]}</h3>
        <p class="card__desc">${place.description[locale] ?? ''}</p>
        <div class="price-list">${rows}</div>
        <button type="button" class="cta" data-place-id="${place.id}">${ctaLabel}</button>
      </div>
    </article>
  `;
}
function navigateToPlace(placeId) {
    const targetPage = authService.isAuthorized ? 'booking' : 'auth';
    window.location.hash = `#page=${targetPage}&place=${placeId}`;
}
export function renderWorkspacesRail(block) {
    const section = document.createElement('section');
    section.className = 'workspaces';
    const tilesContainer = document.createElement('div');
    tilesContainer.className = 'workspaces__tiles';
    tilesContainer.innerHTML = `<p class="workspaces__status">${resolveText('i18n:home.workspacesRail.loading')}</p>`;
    section.innerHTML = `
    <div class="workspaces__heading">
      <div class="eyebrow">${resolveText(block.eyebrow)}</div>
      <h2 class="section-title">${resolveText(block.title)}</h2>
    </div>
  `;
    section.appendChild(tilesContainer);
    const ctaLabel = resolveText(block.ctaLabel);
    fetchPlaces('available')
        .then((places) => {
        tilesContainer.innerHTML = places
            .map((place, index) => renderPlaceCard(place, ctaLabel, index === places.length - 1))
            .join('');
        tilesContainer.querySelectorAll('[data-place-id]').forEach((button) => {
            button.addEventListener('click', () => {
                const placeId = button.dataset.placeId;
                if (placeId)
                    navigateToPlace(placeId);
            });
        });
    })
        .catch((error) => {
        console.error('Failed to load places:', error);
        tilesContainer.innerHTML = `<p class="workspaces__status">${resolveText('i18n:home.workspacesRail.error')}</p>`;
    });
    return section;
}
